export default "__VITE_ASSET__DXmPrLk7__"